module.exports = __webpack_public_path__ + "static/media/20.7306de2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/20.jpg
// module id = 89
// module chunks = 0